// @flow

import * as React from "react"
import type {ItemToInvoice} from "../../types"
import Icon from "../icon"
import {toDinero} from "../../util"

type Props = {
  items: $ReadOnlyArray<ItemToInvoice>,
  hidePrice?: boolean,
  onItemClick?: (ItemToInvoice) => void,
}

class Invoiceables extends React.Component<Props> {
  handleItemClick: (ItemToInvoice) => void

  constructor(props: Props) {
    super(props)
    if (this.props.onItemClick) {
      this.handleItemClick = this.handleItemClick.bind(this)
    } else {
      this.handleItemClick = null
    }
  }

  handleItemClick(babyListItem: ItemToInvoice) {
    if (!babyListItem.items) {
      this.props.onItemClick(babyListItem)
    }
  }

  render() {
    const {items, hidePrice} = this.props
    return (
      <ul className="invoiceable-list">
        {items.map((item) => (
          <Invoiceable
            key={`invoiceable-${item.id}`}
            onClick={this.handleItemClick}
            hidePrice={hidePrice}
            item={item}
          />
        ))}
      </ul>
    )
  }
}

type InvoiceableProps = {
  item: ItemToInvoice,
  hidePrice?: boolean,
  onClick: (ItemToInvoice) => void,
}

class Invoiceable extends React.Component<InvoiceableProps> {
  handleClick: (ItemToInvoice) => void

  constructor(props) {
    super(props)
    if (this.props.onClick) {
      this.handleClick = this.handleClick.bind(this)
    } else {
      this.handleClick = null
    }
  }

  handleClick(item: ItemToInvoice) {
    this.props.onClick(item)
  }

  renderProduct(item: ItemToInvoice) {
    const attrs = this.handleClick
      ? {onClick: () => this.handleClick(item)}
      : {}
    return (
      <li {...attrs}>
        {this.handleClick ? (
          <Icon name="icon-pulse" />
        ) : (
          <Icon name="icon-pulse" />
        )}
        <span className="description">
          {item.amount > 1 && <React.Fragment>{item.amount} x </React.Fragment>}
          {item.name}
          {this.props.hidePrice != true ? (
            <span className="text-gray is-nfw">
              {toDinero(item.total).toFormat("$0,0.00")}
            </span>
          ) : (
            ""
          )}
        </span>
      </li>
    )
  }

  renderProductSet(item: ItemToInvoice) {
    if (!item.items) return null
    return (
      <li className="is-set">
        <span className="description">
          {item.amount > 1 && <React.Fragment>{item.amount} x </React.Fragment>}
          {item.name}
        </span>
        <ul>{item.items.map((i) => this.renderProductSetItem(item, i))}</ul>
      </li>
    )
  }

  renderProductSetItem(item: ItemToInvoice, i: any) {
    return (
      <li
        key={`${item.key}-${i.id}`}
        className="is-set-item"
        onClick={() => this.handleClick(i)}
      >
        <Icon name="icon-plus" />
        <span className="description">
          {i.amount > 1 && <React.Fragment>{i.amount} x </React.Fragment>}
          {i.name}
          <span className="small text-gray pl-1 is-nfw">
            {toDinero(i.total).toFormat("$0,0.00")}
          </span>
        </span>
      </li>
    )
  }

  render() {
    const {item} = this.props
    return item.items ? this.renderProductSet(item) : this.renderProduct(item)
  }
}

export default Invoiceables
